import nfetch from "@/utils/events/nfetch";

export default class SpedService {
    private controllerName = "SPED";

    public geraTXT(data: object): Promise<Response> {
        return nfetch(`/${this.controllerName}/Get?filters=${JSON.stringify(data)}`, {
            method: "get",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    }
}
